/** ISO timestamp -> "6 Oct 2026". Returns the input when it doesn't parse. */
export const formatDayMonthYear = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

/** ISO timestamp -> "14:05". Empty string when it doesn't parse. */
export const formatTimeOfDay = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
};

/** ISO timestamp -> "6 Oct 2026, 14:05". Returns the input when it doesn't parse. */
export const formatDayMonthYearTime = (iso: string): string => {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
